module.exports = __webpack_public_path__ + "static/3-ARPANET-1969-1c5f74a01a76efc7d16c065452ee0bef.jpg";